import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon GreyIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const GreyIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 16 16">
      <circle cx={8} cy={8} r={7.5} stroke="#949494" strokeDasharray="2 2" />
      <path
        d="M7.18066 8.46085C7.18066 7.62654 7.85701 6.9502 8.69132 6.9502H11.0605C11.8948 6.9502 12.5711 7.62654 12.5711 8.46085C12.5711 9.29517 11.8948 9.97151 11.0605 9.97151H10.1146"
        stroke="#949494"
        strokeLinecap="round"
      />
      <path
        d="M9.09668 8.50723C8.96385 9.37082 8.20987 10.0011 7.33641 9.9787L4.91819 9.91667C4.08873 9.8954 3.42739 9.21688 3.42739 8.38714C3.42739 7.54213 4.1124 6.85712 4.95741 6.85711L5.71387 6.8571"
        stroke="#949494"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default GreyIcon
